import { Logo } from '@air/marketing-primitives';
import { Box, Text } from '@air/zephyr';
import Image from 'next/image';

import { AgencyContainer } from '~/old-marketing/components/agency/AgencyContainer';
import { AgencyForm } from '~/old-marketing/components/forms/AgencyForm';

export const AgencyFormCallToActionSection = () => {
  return (
    <Box as="section" tx={{ zIndex: 1, position: 'relative', backgroundColor: 'macaw600', pt: [72, 96] }}>
      <Box tx={{ zIndex: -1, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden' }}>
        <Image height={829} src="/assets/marketing/agency-form-background.svg" width={1440} />
      </Box>
      <AgencyContainer tx={{ position: 'relative', pb: [56, 124] }}>
        <Box tx={{ maxWidth: 480, mx: 'auto' }}>
          <Text
            as="h3"
            tx={{
              mb: 16,
              color: 'macaw060',
              fontFamily: 'Brice-SemiBoldSemiExpanded',
              fontSize: [28, 36],
              letterSpacing: '0.03em',
              lineHeight: 1.15,
              textAlign: ['left', 'center'],
            }}
          >
            Want your agency on the list?
          </Text>
          <Text
            as="p"
            tx={{ mb: 40, color: 'white', textAlign: ['left', 'center'] }}
            variant={['text-ui-18', 'text-ui-20']}
          >
            Introduce yourself, and we&apos;ll add you shortly.
          </Text>
          <AgencyForm />
        </Box>
        <Box tx={{ display: ['none', 'flex'], alignItems: 'flex-end', position: 'absolute', bottom: 24, right: 0 }}>
          <Text tx={{ color: 'flamingo050', mr: 8 }} variant="text-ui-18">
            Made with love by
          </Text>
          <Box tx={{ height: 36, pb: 4 }}>
            <Logo css={{ fill: '$peacock400', height: '100%' }} />
          </Box>
        </Box>
      </AgencyContainer>
    </Box>
  );
};
